import {
  collection,
  doc,
  getDoc,
  getDocs,
  limit,
  orderBy,
  query,
  where,
} from 'firebase/firestore';
import { db } from '../lib/firebase';

const PAGE_SIZE = 10;

export const COMPROBANTE_TYPES = {
  factura: { col: 'factura', label: 'Factura', tipoDoc: '01' },
  boleta: { col: 'boleta', label: 'Boleta', tipoDoc: '03' },
  NC: { col: 'NC', label: 'Nota de crédito', tipoDoc: '07' },
  ND: { col: 'ND', label: 'Nota de débito', tipoDoc: '08' },
};

export function mapInvoice(type, snap) {
  const data = snap.data();
  return {
    id: snap.id,
    collection: type,
    tipoLabel: COMPROBANTE_TYPES[type]?.label || type,
    ...data,
  };
}

/**
 * Lista comprobantes electrónicos del tenant.
 * Colecciones reales: factura, boleta, NC, ND.
 * Lazy: limit por colección; NO descarga todo el histórico.
 */
export async function listInvoices({ ruc, type = 'all', pageSize = PAGE_SIZE, desde = null, hasta = null, search = '' }) {
  if (!ruc) throw new Error('RUC requerido');
  const types = type === 'all' ? ['factura', 'boleta', 'NC', 'ND'] : [type];

  const perType = Math.max(1, Math.ceil(pageSize / types.length));

  const batches = await Promise.all(
    types.map(async (t) => {
      const constraints = [where('ruc', '==', ruc)];
      if (desde) constraints.push(where('fechaEmision', '>=', desde));
      if (hasta) constraints.push(where('fechaEmision', '<=', hasta));
      constraints.push(orderBy('fechaEmision', 'desc'));
      constraints.push(limit(perType));
      const snap = await getDocs(query(collection(db, COMPROBANTE_TYPES[t].col), ...constraints));
      return snap.docs.map((d) => mapInvoice(t, d));
    })
  );

  let items = batches.flat();
  if (search) {
    const term = search.trim().toLowerCase();
    items = items.filter((c) => {
      const serieNum = `${c.serie || ''}-${c.correlativo ?? ''}`.toLowerCase();
      const cliente = String(c.rznSocial || c.numDoc || '').toLowerCase();
      return serieNum.includes(term) || cliente.includes(term);
    });
  }

  items.sort((a, b) => {
    const da = new Date(a.fechaEmision || 0);
    const db = new Date(b.fechaEmision || 0);
    return db - da;
  });

  return {
    items: items.slice(0, pageSize),
    hasMore: batches.some((b) => b.length >= perType),
  };
}

export async function getInvoice(type, id) {
  const meta = COMPROBANTE_TYPES[type];
  if (!meta) throw new Error('Tipo de comprobante no soportado');
  const snap = await getDoc(doc(db, meta.col, id));
  if (!snap.exists()) throw new Error('Comprobante no encontrado');
  return mapInvoice(type, snap);
}
